<template>
    <div id="odiv">
        <p class="p1" v-show="!routerID">&nbsp;&nbsp;新增入库</p>
        <p class="p1" v-show="routerID">&nbsp;&nbsp;修改详情</p>
        <p class="p2">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label=" 供应商:">
                    <el-input style="width: 150px" placeholder="供应商" :class="{margintop:active}" v-model="supplier"
                              clearable></el-input>
                </el-form-item>

                <el-form-item label=" 供应商电话:">
                    <el-input style="width: 150px" placeholder="供应商电话" :class="{margintop:active}"
                              v-model="supplierPhone" clearable></el-input>
                </el-form-item>

                <el-form-item label="备注:">
                    <el-input :class="{margintop:active}" v-model="remarks" placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
        </p>
        <el-table :data="item_1" stripe style="width: 98%;border:0;margin-left: 18px" row-key="rowkey" border
                  :header-cell-style="tableHeaderColor">
            <el-table-column type="index" label="序号" width="auto"></el-table-column>
            <el-table-column prop="value" label="药品名称" width="auto"></el-table-column>
            <!--<el-table-column prop="manufacturer" label="产地" width="auto"></el-table-column>-->
            <el-table-column prop="unit" label="单位" width="auto"></el-table-column>

            <el-table-column prop="orderNumber" label="订单数量">
                <template slot-scope="{row}">
                    <el-input v-model="row.orderNumber" :class="{input:active}"
                              @input="handleOrderNumberChange(row.id,$event)"></el-input>
                </template>
            </el-table-column>

            <el-table-column prop="inNumber" label="入库数量">
                <template slot-scope="{row}">
                    <el-input :class="{input:active}" v-model="row.inNumber"
                              @input="handleInNumberChange(row.id,$event)"></el-input>
                </template>
            </el-table-column>

            <!--<el-table-column prop="retailPrice" label="零售价(￥)"></el-table-column>-->

            <el-table-column prop="costPrice" label="成本价(￥)">
                <template slot-scope="{row}">
                    <el-input v-model="row.costPrice" :class="{input:active}"
                              @input="handleCostPriceChange(row.id,$event)"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="成本合计(￥)" prop="sumAmount">
                <template slot-scope="{row}">
                    {{row.costPriceTotal}}
                </template>
            </el-table-column>
            <el-table-column prop="batchNumber" label="批号">
                <template slot-scope="{row}">
                    <el-input v-model="row.batchNumber" @input="handleBatchNumberChange(row.id, $event)"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="有效期" width="180" prop="effectiveDates">
                <template slot-scope="{row}">
                    <el-date-picker
                            v-model="row.effectiveDates"
                            type="date"
                            style="width: 150px"
                            placeholder="选择日期"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
                <template scope="scope">
                    <el-button @click.native.prevent="deleteRow(scope.$index, item_1)" type="text"
                               size="small">删除
                    </el-button>
                    <!--<el-button type="text" size="small">编辑</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <el-autocomplete :class="{autocomplete:active}" style="width: 98%;margin-left: 18px" v-model="state" :fetch-suggestions="querySearchAsync"
                         placeholder="请搜索" @select="handleSelect"></el-autocomplete>

        <!--
                <p class="p3">合计：<span>0.00</span></p>
        -->
        <el-upload
                style="width: 98%;margin-left:18px;margin-top: 10px"
                class="upload-demo"
                action="/api/upload/singlefile/invoice"
                :on-preview="handlePreview"
                :file-list="fileList2"
                list-type="picture"
                :headers="headers"
                :on-success="onSuccess"
                :on-remove="onRemove"
        >
            <el-button size="small" type="primary">点击上传发票</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
        </el-upload>

        <p class="p4">
            <el-button type="primary" @click="add">保存</el-button>
            <el-button type="info" :plain="true" @click="add_check" v-show="this.routerID">保存并审核</el-button>
            <router-link to="./intoHouse">
                <el-button :plain="true" type="info">取消</el-button>
            </router-link>
            <el-button type="danger" @click="backMedicine" v-show="!this.routerID">退药</el-button>
        </p>
    </div>
</template>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    #odiv { 
        width: 100%;
        /*margin-left: 18px;*/
        padding-bottom: 50px;
        background-color: white;

    }

    .input {
        width: 70px;
        margin-left: 0;
    }

    p {
        width: 100%;
        padding-left: 6px;
        border-bottom: 1px solid #e7e7e7;
        color:#95b2d4;
        height: 50px;
        line-height: 61px;
        /*font-family: 微软雅黑;*/
    }

    .p1 {
        height: 50px;
        font-size: 20px;
    }

    .p2 {
        height: 65px;
        font-size: 15px;
        padding-left:16px;
    }

    .p3 {
        height: 65px;
        border-bottom: 1px solid #e7e7e7;
    }

    .p3 span {
        margin-left: 1000px;
    }

    .el-form .el-form-item .el-date-picker {
        margin-top: 10px;
    }

    .p4 {
        margin: 5px 10px;
        border: 0;
    }

    .margintop {
        margin-top: 16px;
    }

    .autocomplete {
        width: 100%;
        margin-top: 10px;
    }
</style>
<script>

  export default {
    data() {
      return {
        fileList2: [],
        headers: {"Authorization": localStorage.token},
        routerID: '',
        styleValue: '',
        remarks: '',
        supplier: '',
        supplierPhone: '',
        pickerOptions0: {},
        active: true,
        num: '13',
        intotime: Date.now(),
        restaurants: [],
        state: '',
        timeout: null,
        tableData3: [],
        item_1: [],
        inputInx: '',
        storage: '',                 // 入库
        costing: '',                 // 成本
        is_check: '',
        effectiveDates: '',
        url: '',
        inStoreRequst: {
          "storageDetails": [],
          "remarks": '',
          "supplier": '',
          "supplierPhone": '',
          "invoice": ''
        },
        sumAmount: ''
      }
    },
    mounted: function () {

      this.$axios({
        url: '/api/medicines',
        method: 'GET'
      }).then(res => {
        this.tableData1 = res.data.data;
        this.restaurants = this.loadAll();
      }).catch(err => {
        console.log(err.data);
        this.$message({
          type: 'danger',
          message: '获取数据失败'
        })
      });


      //////////////////////////////接受过来的参数
      this.routerID = this.$route.query.id;
      if (this.routerID != '' && this.routerID != undefined) {
        this.$axios({                       //获取修改数据
          url: '/api/medicine/instore/' + this.routerID,
          method: 'GET'
        }).then(res => {
          this.remarks = res.data.data.remarks;
          this.supplier = res.data.data.supplier;
          this.supplierPhone = res.data.data.supplierPhone;
          this.item_1 = res.data.data.inStoreDetailsResponses;
          if (res.data.data.invoice) {
            this.fileList2 = JSON.parse(res.data.data.invoice);
          }
          this.restaurants = this.loadAll();
        })

      }

    },
    methods: {
      handleRemove(file, fileList) {
      },
      handlePreview(file) {

      },
      deleteRow(index, rows) {

        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          rows.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      tableHeaderColor({row, column, rowIndex, columnIndex}) {
        if (rowIndex === 0) {
          return "background-color:#f2f2f2;color: #a4a7af;";        }
      },
      loadAll() {
        return this.tableData1;
      },
      querySearchAsync(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 300 * Math.random());
      },
      createStateFilter(queryString) {
        return (state) => {
          return (state.value.indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        item.batchNumber = 0;
        item.inNumber = 0;
        item.orderNumber = 0;
        item.costPriceTotal = 0;
        item.active=true;
        this.item_1.push(item);
        this.state = '';
      },
      //图片上传成功回调
      onSuccess: function (response, file, fileList) {
        var file = {name: "dd", url: response.data};
        this.fileList2.push(file);
        this.url = JSON.stringify(this.fileList2);
      },

      //删除回调
      onRemove: function (file, fileList) {
        var filelist3 = this.fileList2;
        let url = file.url;
        var cnt = filelist3.length;
        for (var i = 0; i < cnt; i++) {
          if (url == filelist3[i].url) {
            this.fileList2.splice(i, 1);
            break
          }
        }
        this.url = JSON.stringify(this.fileList2)
      },
      add: function () {
        this.inStoreRequst.storageDetails = [];
        //修改的方法
        if (this.routerID != '' && this.routerID != undefined) {
          console.log(this.item_1);
          for (let k = 0; k < this.item_1.length; k++) {
            if (isNaN(this.item_1[k].costPrice)){   // 增加成本价格式检查和提示
              this.$alert('填写的成本价不正确<'+ this.item_1[k].costPrice +'>,请检查！')
              return false
            }
            let inStore={};
            if (this.item_1[k].active==true) {
              inStore = {
                "medicinesId": this.item_1[k].id,
                "batchNumber": this.item_1[k].batchNumber,
                "costPrice": this.item_1[k].costPrice,
                "inNumber": this.item_1[k].inNumber,
                "orderNumber": this.item_1[k].orderNumber,
                "effectiveDates": this.item_1[k].effectiveDates,
                "costPriceTotal": this.item_1[k].costPriceTotal,
              };
            }else {
               inStore = {
                "id":this.item_1[k].id,
                "medicinesId": this.item_1[k].medicineId,
                "batchNumber": this.item_1[k].batchNumber,
                "costPrice": this.item_1[k].costPrice,
                "inNumber": this.item_1[k].inNumber,
                "orderNumber": this.item_1[k].orderNumber,
                "effectiveDates": this.item_1[k].effectiveDates,
                "costPriceTotal": this.item_1[k].costPriceTotal,
              };
            }

            this.inStoreRequst.storageDetails.push(inStore);
          }
          this.inStoreRequst.remarks = this.remarks;
          this.inStoreRequst.supplier = this.supplier;
          this.inStoreRequst.supplierPhone = this.supplierPhone;
          this.inStoreRequst.invoice = this.url;

          let a = this.inStoreRequst.supplier;
          let b = this.inStoreRequst.supplierPhone;

          if (a !== '' && b !== '' && this.item_1.length > 0) {
            this.$axios({
              url: '/api/medicine/instore/' + this.routerID,
              method: 'PUT',
              data: this.inStoreRequst
            }).then(res => {
              if (res.data.code == 200) {
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
              }
              this.$router.push({path: './intoHouse'})
            }).catch(err => {
              console.log(err.data)
            })
          } else {
            this.$alert('填写信息不完整，请检查！')
          }
        } else {
          //新增保存的方法
          this.inStoreRequst.remarks = this.remarks;
          this.inStoreRequst.supplier = this.supplier;
          this.inStoreRequst.supplierPhone = this.supplierPhone;
          this.inStoreRequst.invoice = this.url;
          let a = this.inStoreRequst.supplier;
          let b = this.inStoreRequst.supplierPhone;
          console.log(this.inStoreRequst);
          if (a !== '' && b !== '' && this.item_1.length > 0) {
              for (let k = 0; k < this.item_1.length; k++) {
                if (isNaN(this.item_1[k].costPrice)){   // 增加成本价格式检查和提示
                  this.$alert('填写的成本价不正确<'+ this.item_1[k].costPrice +'>,请检查！')
                  return false
                }
                  let inStore = {
                      "medicinesId": this.item_1[k].id,
                      "batchNumber": this.item_1[k].batchNumber,
                      "costPrice": this.item_1[k].costPrice,
                      "inNumber": this.item_1[k].inNumber,
                      "orderNumber": this.item_1[k].orderNumber,
                      "costPriceTotal": this.item_1[k].costPriceTotal,
                      "effectiveDates": this.item_1[k].effectiveDates
                  };
                  this.inStoreRequst.storageDetails.push(inStore);
              }
            console.log(this.inStoreRequst)
            this.$axios({
              url: '/api/medicine/instore',
              method: 'POST',
              data: this.inStoreRequst
            }).then(res => {
              if (res.data.code == 200) {
                this.item_1 = [];
                this.remark = '';
                this.supplier = '';
                this.supplierPhone = '';
                this.$message({
                  type: 'success',
                  message: '保存成功'
                })
              }
              this.$router.push({path: './intoHouse'})
            }).catch(err => {
              console.log(err.data)
            })
          } else {
            this.$alert('填写信息不完整,请检查！')
              return false

          }

        }

      },
      add_check: function () {
        this.$axios({
          url: '/api/medicine/instore/review/' + this.routerID,
          method: 'PUT'
        }).then(res => {
            //完后再更新
            this.add();
        }).catch(err => {
          console.log(err.data);
        })
      },
      //退药
      backMedicine: function () {
        for (let k = 0; k < this.item_1.length; k++) {
          let inStore = {
            "medicinesId": this.item_1[k].id,
            "batchNumber": this.item_1[k].batchNumber,
            "costPrice": this.item_1[k].costPrice,
            "inNumber": this.item_1[k].inNumber,
            "orderNumber": this.item_1[k].orderNumber,
            "effectiveDates": this.item_1[k].effectiveDates,
            "costPriceTotal": this.item_1[k].costPriceTotal
          };
          this.inStoreRequst.storageDetails.push(inStore);
        }
        this.inStoreRequst.remarks = this.remarks;
        this.inStoreRequst.supplier = this.supplier;
        this.inStoreRequst.supplierPhone = this.supplierPhone;

        let a = this.inStoreRequst.supplier;
        let b = this.inStoreRequst.supplierPhone;

        if (a !== '' && b !== '' && this.item_1.length > 0) {
          this.$axios({
            url: '/api/medicine/instore/returnGoods',
            method: 'POST',
            data: this.inStoreRequst
          }).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: 'success',
                message: '退药成功'
              })
            }
            this.$router.push({path: './intoHouse'})
          }).catch(err => {
            console.log(err.data);
          })
        } else {
          this.$alert('请输入完整信息')
        }
      },

      tableDbEdit(row, column, cell, event) {
        console.log(row, column, cell, event);
      },


      handleInNumberChange(itemId, val) {
        const newItems = this.item_1.map(item => {
          if (item.id === itemId) {
            item.inNumber = Number(val);
            item.costPriceTotal = item.inNumber * item.costPrice;
            item.costPriceTotal = (item.costPriceTotal).toFixed(2)
          }
          return item;
        });
        this.item_1 = newItems;
      },

      handleCostPriceChange(itemId, val) {
        const newItems = this.item_1.map(item => {
          if (item.id === itemId) {
            item.costPrice = val;
            item.costPriceTotal = item.inNumber * Number(val);
            item.costPriceTotal = (item.costPriceTotal).toFixed(2)
          }
          return item;
        });
        this.item_1 = newItems;
      },
      handleOrderNumberChange(itemId, val) {
        const newItems = this.item_1.map(item => {
          if (item.id === itemId) {
            item.orderNumber = Number(val);
          }
          return item;
        });
        this.item_1 = newItems;
      },
      handleBatchNumberChange(itemId, val) {
        const newItems = this.item_1.map(item => {
          if (item.id === itemId) {
            item.batchNumber = val;
          }
          return item;
        });
        this.item_1 = newItems;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// newinto.vue?7b717566